// This file is replaced by the protoc-gen-vendasta-ts generator.
// Manual edits will be overwritten on the next generation run.
export const HOST_OVERRIDES: Record<string, string> = {};
